export default "__VITE_ASSET__Bbu1_C86__"